import Api from "../Service/api";
import NMIFile from "./NewPaymentMethods/NMI";
import ACHFile from "./NewPaymentMethods/Ach";
import { T } from "../app-utils/translator";
import RapydFile from "./NewPaymentMethods/Rapyd";
import WorldPay from "./NewPaymentMethods/WorldPay";
import WorldPayAccess from "./NewPaymentMethods/WorldPayAccess";
import NmiAchFile from "./NewPaymentMethods/NMIACH";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useContext, useState, useEffect } from "react";
import { AutoShipContext, LoadingContext } from "../App";
import { Form, Col, Row, Select, Input } from "antd";
import { appMessage as message } from "../app-utils/antdFeedback";
import { LeftOutlined, RightCircleOutlined } from '@ant-design/icons';
import Citon from "./NewPaymentMethods/Citcon";
// import GPay from "./NewPaymentMethods/GPay";

const api = new Api();
const { Option } = Select

const PaymentAdd = ({ availableConnectors, refreshPaymentList, cardEditDetails }) => {

    const [editForm] = Form.useForm();
    const [selectedConnector, setSelectedConnector] = useState();
    const [allAvailablePayments, setAllAvailablePayments] = useState();
    const [selectedPaymentChannel, setSelectedPaymentChannel] = useState();

    const { setLoading } = useContext(LoadingContext);
    const { autoShipDetails } = useContext(AutoShipContext);

    useEffect(() => {
        if(cardEditDetails?.uuid) {
            return
        }
        if(availableConnectors?.length > 0) {
            const cards = [{paymentChannel: 'CARD', paymentChannelId: 3, connectors: availableConnectors.filter(data => data.paymentChannelId === 3)}]
            const banks = [{paymentChannel: 'BANK', paymentChannelId: 2, connectors: availableConnectors.filter(data => data.paymentChannelId === 2)}]
            const shouldIncludeBanks = availableConnectors.some(data => data.paymentChannelId === 2);
            setAllAvailablePayments([...cards, ...(shouldIncludeBanks ? banks : [])]);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if(allAvailablePayments?.length > 0) {
            updateSelectedChannel(allAvailablePayments[0]);
        }
        // eslint-disable-next-line
    }, [allAvailablePayments]);


    const updateSelectedChannel = (data) => {
        setSelectedPaymentChannel(data);
    }

    useEffect(() => {
        if(selectedPaymentChannel && selectedPaymentChannel?.connectors) {
            setSelectedConnector(selectedPaymentChannel?.connectors[0].displayName)
        }
        // eslint-disable-next-line
    }, [selectedPaymentChannel]);

    const handleValueChange = (obj) => {
        if(obj.expiryDate) {
            var expFormatted;
            var expMonth = ((obj.expiryDate.split(' / ')[0]));
            var expYear = obj.expiryDate.split(' / ')[1];
            if (expYear) {
                expYear = obj.expiryDate.split(' / ')[1].trim()
            }
            if (expMonth) {
                expMonth = obj.expiryDate.split(' / ')[0].trim()
            }
            if (obj.expiryDate.length <= 8) {
                if (!expYear) {
                    if (expMonth > 1 && expMonth.length === 1) {
                        expMonth = '0'.concat(expMonth);
                    }
                    expFormatted = (expMonth.match(/.{1,2}/g)).join(' / ');
                } else {
                    expFormatted = expMonth.concat(' / ');
                    expFormatted = expFormatted.concat(expYear);
                }
            } else {
                expFormatted = expMonth.concat(' / ').concat(expYear.substring(0, 4));
            }
            editForm.setFieldsValue({ "expiryDate": expFormatted });
        }
    }

    const formatNumber = (number) => {
        return number.toString().padStart(2, '0');
    }

    const handleKeyPress = (event) => {
        const charCode = event.charCode;
        if (charCode < 48 || charCode > 57) {
          event.preventDefault();
        }
    };

    const onCardEditUpdate = async(data) => {
        let url = 'pgapi/edit-payment-instrument';
        const body = {
            "paymentInstrumentUuid" : cardEditDetails?.uuid,
            "expiryMonth" : data.expiryDate.split(' / ')[0],
            "expiryYear" : data.expiryDate.split(' / ')[1],
        }
        setLoading(true);
        var result = await api.mainRestCallService(url, 'POST', body);
        setLoading(false);
        if (result?.status === 1) {
            refreshPaymentList();
            message.success(T('cardUpdatedSuccessfully'));
        } else {
            message.error(T('failedUpdateCard'))
        }
    }

    return (
        <div className="mt-4">
            {
                (!cardEditDetails?.gw_payment_instrument_id) &&
                <div className="">
                    {
                        ((allAvailablePayments?.length > 0)) &&
                        <>
                            <div className={'d-flex align-items-center justify-content-between'}>
                                <h5 className="mb-0"><b>{T('selectPayment')}</b></h5>
                                <p className="mb-0 link" onClick={() => refreshPaymentList()}><ArrowLeftOutlined /> {T('back')}</p>
                            </div>
                            <div className={'d-flex align-items-center justify-content-start mt-4'}>
                                {
                                    allAvailablePayments?.map(data => (
                                        <div key={data?.paymentChannelId} className={"buttonView " + ((selectedPaymentChannel?.paymentChannelId === data?.paymentChannelId) && 'buttonViewActive')}>
                                            <p onClick={() => updateSelectedChannel(data)} className="mb-0 text-center">
                                                {(data?.paymentChannelId === 3) ? T('card_text') : T('bank_text')}
                                            </p>
                                        </div>
                                    ))
                                }
                            </div>
                        </>
                    }
                    {
                        (selectedPaymentChannel?.paymentChannelId === 3 && selectedPaymentChannel?.connectors?.length >= 1) &&
                        <div className="mt-4 ">
                            <label className="mb-0">{T('cardType')}</label>
                            <Select className="form-control" onChange={($event) => setSelectedConnector($event)} value={selectedConnector} style={{ width: '100%' }} placeholder={T('select')}>
                                {selectedPaymentChannel?.connectors
                                    ?.filter((data) => (
                                        data.displayName !== 'GPAY_VIA_WORLDPAY' &&
                                        data.displayName !== 'APPLEPAY_VIA_WORLDPAY'
                                    ))
                                    .map((data) => (
                                        (data.displayName !== 'WORLDPAY'  && data.displayName !== 'WORLDPAY_ACCESS') ? (
                                            <Option key={data?.displayName} value={data?.displayName}>
                                                {(data.displayName === 'RAPYD') ? ((autoShipDetails?.currency === "USD") ? T('ccintl') : T('mater_visa')) : ((autoShipDetails?.currency === "GBP" || autoShipDetails?.currency === "EUR") ? ((data.displayName === 'CITCON_PAYMENT') ? 'Card Citcon' : T('amex_card_text')) : (autoShipDetails?.currency === 'USD') ? ((data.displayName === 'CITCON_PAYMENT') ? 'Card Citcon' : T('credit_card')) : ((data.displayName === 'CITCON_PAYMENT') ? 'Card Citcon' : T('amex_dis')))}
                                            </Option>
                                        ) : 
                                        ((data.displayName === 'WORLDPAY') ? <Option key={data?.displayName} value={data?.displayName}>
                                                   {(T('add_card_text') + '(WPay)')}
                                                </Option> : <Option key={data?.displayName} value={data?.displayName}> {(T('add_card_text') + ' (WPay Access)')}</Option>)
                                    ))}
                            </Select>
                        </div>
                    }

                    {(selectedConnector === 'RAPYD') && <RapydFile connector={selectedPaymentChannel?.connectors?.find(data => data?.displayName === 'RAPYD')} refreshPaymentList={refreshPaymentList} />}

                    {(selectedConnector === 'NMI') && <NMIFile connector={selectedPaymentChannel?.connectors?.find(data => data?.displayName === 'NMI')} refreshPaymentList={refreshPaymentList} />}

                    {(selectedConnector === 'NMI_ACH') && <NmiAchFile connector={selectedConnector} refreshPaymentList={refreshPaymentList} />}

                    {(selectedConnector === 'WORLDPAY') && <WorldPay connector={selectedPaymentChannel?.connectors?.find(data => data?.displayName === 'WORLDPAY')} refreshPaymentList={refreshPaymentList} />}

                    {(selectedConnector === 'WORLDPAY_ACCESS') && <WorldPayAccess connector={selectedPaymentChannel?.connectors?.find(data => data?.displayName === 'WORLDPAY_ACCESS')} refreshPaymentList={refreshPaymentList} />}

                    {/* {(selectedConnector === 35) && <GPay connector={selectedConnector} refreshPaymentList={refreshPaymentList} />} */}

                    {(selectedConnector === 'CITCON_PAYMENT') && <Citon connector={selectedPaymentChannel?.connectors?.find(data => data?.displayName === 'CITCON_PAYMENT')} refreshPaymentList={refreshPaymentList} />}

                    {(selectedConnector === 'INTERNAL' && selectedPaymentChannel?.paymentChannelId === 2) && <ACHFile connector={selectedConnector} refreshPaymentList={refreshPaymentList} />}
                </div>
            }

            {
                (cardEditDetails?.gw_payment_instrument_id) &&
                <div>
                    <Row className="mainRow" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="center">
                        <Form className="NMI" form={editForm} layout="vertical" style={{ width: '100%', marginTop: 24 }} onValuesChange={handleValueChange} onFinish={onCardEditUpdate} initialValues={{ expiryDate: `${formatNumber(cardEditDetails?.exp_month)} / ${cardEditDetails?.exp_year}`, name: cardEditDetails?.account_name, number: `XXXX XXXX XXXX ${cardEditDetails?.card_number_last4}` }}>
                            <Col className="" span={24} style={{ marginBottom: 24 }}>
                                <Form.Item disabled={true} name="number" label={T('card_number')} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                                    rules={[
                                        { required: true, message: T('InvalidCardNumber') },
                                    ]}>
                                    <Input key="ach-accountnumber" placeholder={T('card_number')} minLength={3} disabled={true} />
                                </Form.Item>
                            </Col>

                            <Col className="" span={24} style={{ marginBottom: 24 }}>
                                <Form.Item name="expiryDate" label={T('expiry_date')} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                                    rules={[
                                        () => ({
                                            validator(_, value) {
                                                if (/^(0[1-9]|1[0-2]) \/ \d{4}$/.test(value)) {
                                                    const month = Number(value.split(' / ')[0]);
                                                    const year = Number(value.split(' / ')[1]);
                                                    if ((year > new Date().getFullYear()) || ((year === new Date().getFullYear()) && (month >= (new Date().getMonth() + 1)))) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error(T('InvalidExpirationDate')));
                                                }
                                                return Promise.reject(new Error(T('InvalidExpirationDate')));
                                            },
                                        }),
                                    ]}>
                                    <Input type="text" key="ach-accountnumber" placeholder={T('MM / YYYY')} onKeyPress={handleKeyPress} minLength={7} />
                                </Form.Item>
                            </Col>

                            <Col className="footer">
                                <button className="btn newCardbutton"> <LeftOutlined style={{ color: 'transparent' }} /> {T('submit_text')} <RightCircleOutlined /></button>
                                <small className="text-primary" style={{ fontSize: '16px', cursor: 'pointer' }} onClick={refreshPaymentList}>{T('cancel_text')}</small>
                            </Col>

                        </Form>

                    </Row>
                </div>
            }
        </div>
    )
}

export default PaymentAdd;
